<ng-template #payment let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Request to make Payment - {{obligationPayment.bcfReferenceNumber}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="col">
      <div class="col-12">
        <div class="col-12 pb-3">
        <div class="row">
          <div class="col col-12 alert alert-info">If you require assistance, email  <a [href]="'mailto:bcfpayments@bct.nsw.gov.au?subject=Request for Payment Application Change - ' + obligationPayment.bcfReferenceNumber">bcfpayments@bct.nsw.gov.au</a>
          </div>
        </div>
      </div>

        <div class="row">
          <div class="col-10 form-group form-inline">
            <label class="control-label col-4 text-left d-inline-block">Proponent name</label><span class="ml-1">{{applicantName}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-10 form-group form-inline">
            <label class="control-label col-4 text-left d-inline-block">Development name</label><span class="ml-1">{{developmentName}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-10 form-group form-inline">
            <label class="control-label col-4 text-left d-inline-block">Is the proponent above the same entity making the payment?</label><span class="ml-1">{{payerSameAsApplicant ? 'Yes' : 'No'}}</span>
          </div>
        </div>
        <div *ngIf="!payerSameAsApplicant && payer" class="row">
          <div class="col-10 form-group form-inline">
            <label class="control-label col-4 text-left d-inline-block">Payer name</label><span class="ml-1">{{payer.firstName}}</span>
          </div>
          <div class="col-10 form-group form-inline">
            <label class="control-label col-4 text-left d-inline-block">Payer ABN</label><span class="ml-1">{{payer.abn}}</span>
          </div>
          <div class="col-10 ml-3 row form-group form-inline">
           <h5>Payer contact details</h5>
         </div>

          <div class="col-12 ml-3 row">
            <div class="col-md-6">
              <div class="form-group form-inline">
                <label class="control-label col-5 text-left d-inline-block">First name</label><span class="ml-1">{{payer?.contacts?.[0]?.firstName}}</span>
              </div>
              <div class="form-group form-inline">
                <label class="control-label col-5 text-left d-inline-block">Second name</label><span class="ml-1">{{payer?.contacts?.[0]?.lastName}}</span>
              </div>
              <div class="form-group form-inline">
                <label class="control-label col-5 text-left d-inline-block">Email address</label><span class="ml-1">{{payer?.contacts?.[0]?.email}}</span>
              </div>
              <div class="form-group form-inline">
                <label class="control-label col-5 text-left d-inline-block">Phone number</label><span class="ml-1">{{payer?.contacts?.[0]?.phone}}</span>
              </div>
              <div class="form-group form-inline">
                <label class="control-label col-5 text-left d-inline-block">Mobile number</label><span class="ml-1">{{payer?.contacts?.[0]?.mobile}}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group form-inline">
                <label class="control-label col-6 text-left d-inline-block">Payer Mailing address</label>
              </div>
              <div class="form-group form-inline">
                <label class="control-label col-6 text-left d-inline-block">PO Box/ Address</label><span class="ml-1">{{payer?.addresses?.[0]?.address1}}</span>
              </div>
              <div class="form-group form-inline">
                <label class="control-label col-6 text-left d-inline-block">Suburb / City</label><span class="ml-1">{{payer?.addresses?.[0]?.suburb}}</span>
              </div>
              <div class="form-group form-inline">
                <label class="control-label col-6 text-left d-inline-block">State / Territory</label><span class="ml-1">{{payer?.addresses?.[0]?.state}}</span>
              </div>
              <div class="form-group form-inline">
                <label class="control-label col-6 text-left d-inline-block">Postcode</label><span class="ml-1">{{payer?.addresses?.[0]?.postCode}}</span>
              </div>
            </div>
          </div>         
        </div>

        <div class="row">
          <div class="col-10 form-group form-inline">
            <label class="control-label col-4 text-left d-inline-block">Process status</label><span class="ml-1">{{status}}</span>
            <span class="p-2"><tooltip register="External" tab="BCF Payments" section="Payment details" field="Process status"></tooltip></span>
          </div>
        </div>
        <div class="row">
          <div class="col-10 form-group">
            <label class="control-label col-4 text-left d-inline-block align-top">Documents</label>
            <div class="ml-1 d-inline-block">
              <a href="javascript:void(0)" (click)="downloadRTMP();">RTMP Application</a>
              <span class="p-2"><tooltip register="External" tab="BCF Payments" section="Payment details" field="RTMP Application"></tooltip></span>
              <br/>
              <div class="mt-1" *ngIf="showDownloadCertificate"><a href="javascript:void(0)" (click)="downloadCertificate();">Section 6.33 Certificate</a>
                <span class="p-2"><tooltip register="External" tab="BCF Payments" section="Payment details" field="Certificate"></tooltip></span>
              </div>
            </div>
          </div>
        </div>


      <div id="paymentsDetailsDiv" class="card-body accordion-collapse collapse show">
        <div class="row">
         <div class="col-10 row form-group form-inline">
           <h5>Payment Details</h5>
         </div>
        </div>
        <div class="row">
          <div class="col-10 row form-group form-inline">
            <label class="control-label col-4 text-left d-inline-block">Quote issue date</label><span class="ml-1">{{issuedDate}}</span>
          </div>
        </div>
        <div class="row" *ngIf="!isRFQAfterAmendment">
          <div class="col-10 row form-group form-inline">
            <label class="control-label col-4 text-left d-inline-block">No. of whole months lapsed</label><span class="ml-1">{{monthsLapsed}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-10 row form-group form-inline">
            <label class="control-label col-4 text-left d-inline-block">RTMP Application Date</label><span class="ml-1">{{applicationDate}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-10 row form-group form-inline">
            <label class="control-label col-4 text-left d-inline-block">Payment receipt date</label><span class="ml-1">{{paymentReceiptDate}}</span>
            <div class="ml-auto d-flex align-items-center text-nowrap">
              <label class="control-label mb-0 mr-1">Payment receipt record no.</label><span class="ml-1">{{paymentReceiptRecordNo}}</span>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="showDownloadCertificate">
          <div class="col-10 row form-group form-inline">
            <label class="control-label col-4 text-left d-inline-block">Certificate issue date</label><span class="ml-1">{{certificateIssueDate}}</span>
          </div>
        </div>
        <div class="row">         
        </div>
        <app-quote-credit-payment-grids
          [quoteCredits]="quoteCredits"
          [isRFQAfterAmendment]="isRFQAfterAmendment"
          [bcfPaymentFee]="bcfPaymentFee"
          [scope]="'payment'">
        </app-quote-credit-payment-grids>
      </div>    
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="close()">Close</button>
  </div>
</ng-template>
